module.exports = __webpack_public_path__ + "img/panda.27242654.gif";